import { useRouter } from "next/dist/client/router";
import { useTranslation } from "next-i18next";
import React, { FC, FunctionComponent } from "react";

import { LanguageSwitcher } from "../language-switcher/language-switcher";
import { Link } from "@components/common/link/link";

interface FooterProps {
    center?: boolean;
    narrow?: boolean;
}

export const Footer: FunctionComponent<FooterProps> = ({ center, narrow }) => {
    const { t } = useTranslation();
    const { locale } = useRouter();

    return (
        <footer className={`grid grid-cols-1 gap-y-4 py-6 ${narrow ? "w-full max-w-[450px]" : ""} ${center ? "mx-auto text-center" : ""}`.trim()}>
            <LanguageSwitcher center={center} />
            {/* todo: turn year into current year */}
            <div className={`flex flex-wrap items-center gap-x-4 text-xs ${center ? "justify-center" : ""}`.trim()}>
                {/* todo: add translations + links */}
                <Link className="text-link" href={locale === "de" ? `/nutzungsbedingungen` : `/termsandconditions`}>
                    {t("generic.terms")}
                </Link>
                {/* <Link className="text-link" href="/"> */}
                {/*  {t('generic.ad')} */}
                {/* </Link> */}
                <Link className="text-link" href={locale === "de" ? `/datenschutz` : `/dataprotection`}>{`${t("generic.data_protection")} & ${t(
                    "generic.privacy",
                )}`}</Link>
                <Link className="text-link" href={locale === "de" ? `/datenschutz#cookies` : `/dataprotection#cookies`}>
                    {t("generic.cookies")}
                </Link>
                <Link className="text-link" href={locale === "de" ? `/impressum` : `/imprint`}>
                    {t("generic.imprint")}
                </Link>
                {/* <Link className="text-link" href="/"> */}
                {/*  {t('generic.help')} */}
                {/* </Link> */}
            </div>
            <div className="text-2xs text-gray-500">© Copyright 2025 Realclixx GmbH</div>
        </footer>
    );
};
